<template>
    <div id="tailored-layout">
        <section id="tailored-header">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <img id="tailored-logo" :src="`${assetsUrl}truestock_tailored_logo_new.png`" style="max-width:560px" alt="Tailored Content">
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <h1>Fully managed custom photoshoots</h1>
                    </div>
                </div>
            </div>
        </section>
        <section id="tailored-features-section">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-md-4 col-lg-6 pr-lg-5 text-center">
                        <div v-if="locale === 'nz'" class="swiper-heading">Some projects / clients</div>
                        <swiper v-if="locale === 'nz'" ref="carousel" :options="swiperOption">
                            <swiper-slide><img :src="`${assetsUrl}case-studies/tailored-carousel-botanic.jpg`" alt="Botanic"></swiper-slide>
                            <swiper-slide><img :src="`${assetsUrl}case-studies/tailored-carousel-kiwibank.jpg`" alt="Kiwibank"></swiper-slide>
                            <swiper-slide><img :src="`${assetsUrl}case-studies/tailored-carousel-tepou.jpg`" alt="Te Pou"></swiper-slide>
                            <swiper-slide><img :src="`${assetsUrl}case-studies/tailored-carousel-kaingaora.jpg`" alt="Kainga Ora"></swiper-slide>
                            <swiper-slide><img :src="`${assetsUrl}case-studies/tailored-carousel-mbie.jpg`" alt="MBIE"></swiper-slide>
                            <swiper-slide><img :src="`${assetsUrl}case-studies/tailored-carousel-special.jpg`" alt="Special"></swiper-slide>
                        </swiper>
                        <swiper v-else ref="carousel" :options="swiperOption">
                            <swiper-slide><img :src="`${assetsUrl}case-studies/tailored-carousel-1.jpg`"></swiper-slide>
                            <swiper-slide><img :src="`${assetsUrl}case-studies/tailored-carousel-2.jpg`"></swiper-slide>
                            <swiper-slide><img :src="`${assetsUrl}case-studies/tailored-carousel-3.jpg`"></swiper-slide>
                            <swiper-slide><img :src="`${assetsUrl}case-studies/tailored-carousel-4.jpg`"></swiper-slide>
                        </swiper>
                    </div>
                    <div id="contact-package-btn-col" class="col-12 col-md-8 col-lg-6 pl-lg-5">
                        <h2>Access to custom on-brand photography made <i>really</i> easy.</h2>
                        <p>
                            <strong>One-off pricing.</strong>
                            No recurring talent or photographer licence renewal fee.</p>
                        <p>
                            <strong>Tailored to your budget.</strong>
                            We work with budgets of all shapes and sizes. Decades of combined experience helps us offer you creative solutions especially when time or money is a critical constraint.
                        </p>
                        <p>
                            <strong>One point of contact.</strong>
                            We'll take care of talent, location, wardrobe, post-production and everything else.
                        </p>
                        <a class="btn btn-primary inverted" @click="showContact">Contact Us</a>
                    </div>
                </div>
            </div>
        </section>
        <section id="tailored-approach-section">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <h2>Our Approach</h2>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-lg-6 pr-lg-5">
                        <p>
                            When you partner with us, we take on <br class="d-none d-xl-block">the brief and become your production <br class="d-none d-xl-block">arm, dedicated to capturing everything <br class="d-none d-xl-block">as per
                            your brief.
                        </p>
                    </div>
                    <div class="col-12 col-lg-6 pl-lg-5 right">
                        <p>
                            Instead of sending your brief out to various photographers to see ‘what comes back’, we assign the right photographer (approved by you) and manage the entire bespoke production.
                        </p>
                        <p>
                            We can collaborate with agencies and also work directly with clients.
                        </p>
                        <a @click="showProcessRequest">Request our Process Document</a>
                    </div>
                </div>
            </div>
        </section>
        <div v-if="locale === 'nz'" id="tailored-extras">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <h2>Case Studies</h2>
                        <section class="reason-section pb-0 pt-5 case-studies" ref="case-studies">
                            <div class="">
                                <div class="row">
                                    <div v-for="caseStudy in caseStudies" :key="caseStudy.id" class="col-12 col-md-6 col-lg-4 case-study-col">
                                        <nuxt-link :to="{ name: 'tailored.case-study', params: {slug: caseStudy.url_slug} }" target="_blank">
                                            <h4>
                                                <span class="font-semi-bold">{{ caseStudy.client }}</span>
                                                <span v-if="caseStudy.end_client">{{ caseStudy.end_client }}</span>
                                                <b-icon-arrow-right class="btn-color"/>
                                            </h4>
                                            <img class="w-100" :src="`${caseStudy.thumbnail.url}`">
                                        </nuxt-link>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section>
                            <div class="container">
                                <div class="row">
                                    <div id="contact-process-pricing-btn-col" class="col-12 offset-0 col-md-10 offset-md-1">
                                        <h3 class="mb-5 pb-2">Contact us to find out more about our pricing and process to create bespoke custom images just for you.</h3>
                                        <b-link v-b-modal.contact-modal class="btn btn-primary">Contact us for <br class="d-block d-sm-none">process &amp; pricing</b-link>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>
        <b-modal id="tailored-contact-modal" scrollable :title="modal.title" hide-footer centered>
            <form class="auth-form" @submit.prevent="sendContact" @keydown="form.onKeydown($event)">
                <div class="form-row">
                    <div class="form-group col-sm-12">
                        <label class="required">Name</label>
                        <input v-model="form.name" :class="{ 'is-invalid': form.errors.has('name') }" type="text" name="name" class="form-control">
                        <has-error :form="form" field="name"/>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-sm-12">
                        <label class="required">Contact Email</label>
                        <input v-model="form.email" :class="{ 'is-invalid': form.errors.has('email') }" type="text" name="email" class="form-control">
                        <has-error :form="form" field="email"/>
                    </div>
                </div>
                <div v-if="!form.requestProcess" class="form-row">
                    <div class="form-group col-sm-12">
                        <label class="required">Message</label>
                        <textarea v-model="form.message" rows="4" :class="{ 'is-invalid': form.errors.has('message') }" type="text" name="message" class="form-control"
                                  :placeholder="modal.placeholder"
                        />
                        <has-error :form="form" field="message"/>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-sm-12">
                        <v-button variant="primary" class="float-right btn-lg" :loading="form.busy">
                            Submit
                        </v-button>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-sm-12 mb-0">
                        <div class="hint-text">If you would rather send us a plain old email, you can do so at <span class="btn-color">{{ localeVariables['contact-email'] }}</span></div>
                    </div>
                </div>
            </form>
        </b-modal>
    </div>
</template>

<script>
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import Form from 'vform'
import { mapGetters } from 'vuex'
import axios from 'axios'

export default {
    components: {
        Swiper,
        SwiperSlide
    },
    directives: {
        swiper: directive
    },
    async asyncData ({
        params
    }) {
        const caseStudies = await axios.get('/case-studies').then(rsp => rsp.data.data)

        return {
            caseStudies
        }
    },
    data () {
        return {
            caseStudies: [],
            modal: {
                title: 'Contact Us',
                placeholder: 'Please let us know what you are looking for'
            },
            form: new Form({
                name: '',
                email: '',
                message: '',
                routeName: '',
                option: null,
                requestProcess: false
            }),
            swiperOption: {
                loop: true,
                effect: 'fade',
                autoplay: {
                    delay: 1800
                },
                simulateTouch: false,
                allowTouchMove: false
            }
        }
    },
    head () {
        const title = 'Custom Photoshoots & Tailored Content | Truestock'
        const description = 'Easy image production under one roof. We\'ll source talent, location and New Zealand photographers to create unique imagery made just for you. Enquire today.'

        return {
            title,
            meta: [
                {
                    hid: 'og:title',
                    property: 'og:title',
                    content: title
                },
                {
                    hid: 'twitter:title',
                    name: 'twitter:title',
                    content: title
                },
                {
                    hid: 'description',
                    name: 'description',
                    content: description
                },
                {
                    hid: 'og:description',
                    property: 'og:description',
                    content: description
                },
                {
                    hid: 'twitter:description',
                    name: 'twitter:description',
                    content: description
                }
            ]
        }
    },
    computed: {
        ...mapGetters({
            user: 'auth/user',
            localeVariables: 'data/localeVariables'
        })
    },
    watch: {
        user (newUser, oldUser) {
            this.setUserFields()
        }
    },
    mounted () {
        this.setUserFields()

        this.$nextTick(() => {
            this.$refs.carousel.$swiper.update()

            if (this.$route.hash) {
                const hash = this.$route.hash.replace('#', '')

                if (this.$refs[hash]) {
                    setTimeout(function () {
                        const container = document.getElementById('tailored-extras')

                        if (container) {
                            window.scrollTo({
                                top: container.offsetTop - 70,
                                left: 0,
                                behavior: 'smooth'
                            })
                        }
                    }, 100) // delay in milliseconds
                }
            }
        })
    },
    methods: {
        showContact () {
            this.form.requestProcess = false
            this.modal.title = 'Contact Us'

            this.$bvModal.show('tailored-contact-modal')
        },
        showProcessRequest () {
            this.form.requestProcess = true
            this.modal.title = 'Request process document'

            this.$bvModal.show('tailored-contact-modal')
        },
        setUserFields () {
            if (this.user) {
                this.form.name = `${this.user.first_name} ${this.user.last_name}`
                this.form.email = this.user.email
            }
        },
        async sendContact () {
            this.form.routeName = this.$nuxt.$route.name

            const _this = this
            await this.form.post('/contact/tailored').then((data) => {
                _this.form.message = ''
                this.$toast.success('Thanks for reaching out! We will be in touch soon.')
                this.$bvModal.hide('tailored-contact-modal')
            }).catch((error) => {
                console.log(error)
            })
        }
    }
}
</script>
